import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  VStack,
  HStack,
  useToast,
} from '@chakra-ui/react';

const CreateTicket = () => {
  const [category, setCategory] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [file, setFile] = useState(null);
  const toast = useToast();

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (
      uploadedFile &&
      (uploadedFile.type === 'image/jpeg' || uploadedFile.type === 'image/png')
    ) {
      setFile(uploadedFile);
    } else {
      toast({
        title: 'Invalid file type.',
        description: 'Only .jpeg or .png files are allowed.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      e.target.value = null;
    }
  };

  const handleSubmit = () => {
    console.log({ category, subject, message, file });
    // Add your API submission logic here
  };

  const handleDiscard = () => {
    setCategory('');
    setSubject('');
    setMessage('');
    setFile(null);
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="md"
      p={6}
      bg="white"
      mx="auto"
      mt={6}
      boxShadow="sm"
    >
      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel>Category</FormLabel>
          <Select
            placeholder="Select..."
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="billing">Billing</option>
            <option value="technical">Technical</option>
            <option value="general">General</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Subject</FormLabel>
          <Input
            placeholder="Write Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Message / Query</FormLabel>
          <Textarea
            rows={6}
            placeholder="Type your message here..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Upload (Only .jpeg or .png files are allowed)</FormLabel>
          <Input
            type="file"
            accept=".jpeg, .jpg, .png"
            onChange={handleFileChange}
            p={1}
            variant="unstyled"
          />
        </FormControl>

        <HStack justify="flex-end" pt={4}>
          <Button variant="outline" onClick={handleDiscard} >
            Discard
          </Button>
          <Button  bgColor={"#233B85"}
              color={"white"} onClick={handleSubmit}>
            Submit
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default CreateTicket;
